// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"9dc2ec4a","349":"2562ef8e","380":"2562ef8e","722":"2562ef8e","730":"2562ef8e","768":"2562ef8e","823":"2562ef8e"}[chunkId] + ".chunk.css";
};